import { createAction, props } from '@ngrx/store';
import { CandidateExtraInfo } from '@shared/models/candidate-extra-info';

export const candidatesExtraInfoLoad = createAction(
  '[Collection Candidate Extra Info] Load ',
  props<{ candidateIds: number[] }>(),
);
export const candidatesExtraInfoLoadSuccess = createAction(
  '[Collection Candidate Extra Info] Load Success',
  props<{ payload: CandidateExtraInfo[] }>(),
);
export const candidatesExtraInfoLoadFail = createAction(
  '[Collection Candidate Extra Info] Load Fail',
  props<{ any }>(),
);
